import { FgStockStatus } from "./fg-stock-status.enum";
import { StockStatus } from "./stock-status.enum";

export class FGReStockData{
    stockId: number;
    saleOrderId: number;
    saleOrderNumber: string;
    saleOrderItemId: number;
    brandId: number;
    brand: string;
    minGrade: number;
    maxGrade: number;
    varientId: number;
    variantName: string;
    pouches: number;
    pouchWeight: number;
    categoryId: number;
    category: string;
    productId: number;
    product: string;
    quantity: number;
    locationId: number;
    location: string;
    palletId: number;
    pallet: number;
    date:Date;
    stockType: StockStatus;
    status: FgStockStatus;
    assigningQty?:number;
    assignedSoId?:number;
    assignedSoItemId?:number
    shrimpWeight?:number
    constructor(stockId: number, saleOrderId: number, saleOrderNumber: string, saleOrderItemId: number, brandId: number, brand: string, minGrade: number, maxGrade: number, varientId: number, variantName: string, pouches: number, pouchWeight: number, categoryId: number, category: string, productId: number, product: string, quantity: number, locationId: number, location: string,  date:Date,
    stockType: StockStatus, status: FgStockStatus,palletId: number, pallet: number, assigningQty?:number,assignedSoId?:number,
    assignedSoItemId?:number){
        this.stockId = stockId;
        this.saleOrderId = saleOrderId;
        this.saleOrderNumber = saleOrderNumber;
        this.saleOrderItemId = saleOrderItemId;
        this.brandId = brandId;
        this.brand = brand;
        this.minGrade = minGrade;
        this.maxGrade = maxGrade;
        this.varientId = varientId;
        this.variantName = variantName;
        this.pouches = pouches;
        this.pouchWeight = pouchWeight;
        this.categoryId = categoryId;
        this.category = category;
        this.productId = productId;
        this.product = product;
        this.quantity = quantity;
        this.location = location;
        this.locationId = locationId;
        this.palletId = palletId;
        this.pallet = pallet;
        this.date =date;
        this.stockType = stockType;
        this.status = status;
        this.assigningQty = assigningQty;
        this.assignedSoId = assignedSoId;
        this.assignedSoItemId = assignedSoItemId;
    }

}